module.exports = __webpack_public_path__ + "static/media/ch.f0617e6d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ch.svg
// module id = 620
// module chunks = 0